// Api - Consultas CIC
const hostname = window.location.hostname;
//const remplazo = "#{ambiente.liberacion}#"; // Remplazo que se ejecuta durante el release : -int , -pru, -pre, -cap
//const posfijoAmbiente = (remplazo.length > 0) ? `-${remplazo}` : '';

const dominio = hostname.includes("localhost")
  ? `https://localhost/Bccr.Sugef.CIC.Externo.API` // Ambiente de desarrollo
  : `https://${hostname}/Bccr.Sugef.CIC.Externo.API`; // Ambientes

const version = `api-version=1.0`;

// API Padron
const RutaApiPadron = `${dominio}/Padron`;
export const apiPadron = {
  ConsultaPadron: `${RutaApiPadron}/ConsultaPadron?${version}`,
  ParametrosSolicitudPadron: `${RutaApiPadron}/ObtengaParametrosDeConsultaSolicitudPadron?${version}`,
  ObtengaTiposDocumentosSolicitudesPadron: `${RutaApiPadron}/ObtengaTiposDocumentosSolicitudesPadron?${version}`,
  ConsulteSolicitudesPadron: `${RutaApiPadron}/ConsulteSolicitudesPadron?${version}`,
  DetalleSolicitudPadron: `${RutaApiPadron}/ObtengaDetalleSolicitudPadron?${version}`,
  DocumentosDetalleSolicitud: `${RutaApiPadron}/ObtengaDocumentoSolicitudPadron?${version}`,
  GuardarModificacionSolicitud: `${RutaApiPadron}/GuardarModificacionSolicitud?${version}`,
  IngresoSolicitudDePadron: `${RutaApiPadron}/IngreseSolicitudDePadron?${version}`,
  ObtengaPersonaUnificada: `${RutaApiPadron}/ObtengaPersonaUnificada?${version}`,
  ObtengaDatosPasaporte: `${RutaApiPadron}/ObtengaDatosPasaporte?${version}`,
};

//API Comun
const RutaApiComun = `${dominio}/Comun`;
export const apiComun = {
  ObtengaPaises: `${RutaApiComun}/ObtengaPaises?${version}`,
  ObtengaGeneros: `${RutaApiComun}/ObtengaGeneros?${version}`,
  ObtengaTiposPersona: `${RutaApiComun}/ObtengaTiposPersona?${version}`,
  ObtengaTiposDocumento: `${RutaApiComun}/ObtengaTiposDocumento?${version}`,
  ValidarDocumentos: `${RutaApiComun}/ValidarDocumentos?${version}`,
  ObtengaTiposReporteCrediticio: `${RutaApiComun}/ObtengaTiposReporteCrediticio?${version}`,
  ObtengaTiposAutorizacion: `${RutaApiComun}/ObtengaTiposAutorizacion?${version}`,
  ObtengaTiposSolicitudCambio: `${RutaApiComun}/ObtengaTiposSolicitudCambio?${version}`,
  ObtengaEntidadesRelacionadas: `${RutaApiComun}/ObtengaEntidadesRelacionadas?${version}`,
  ObtengaEntidadesPrincipalYRelacionadas: `${RutaApiComun}/ObtengaEntidadesPrincipalYRelacionadas?${version}`,
  ObtengaTiposMotivoLiquidacion: `${RutaApiComun}/ObtengaTiposMotivoLiquidacion?${version}`,
  ObtengaTiposOperacion: `${RutaApiComun}/ObtengaTiposOperacion?${version}`,
  ObtengaContactosCic: `${RutaApiComun}/ObtengaContactosCic?${version}`,
};

//API Inforamacion Crediticia
const rutaApiInformacionCrediticia = `${dominio}/InformacionCrediticia`;
export const apiInformacionCrediticia = {
  ObtengaReporteCrediticio: `${rutaApiInformacionCrediticia}/ObtengaReporteCrediticio?${version}`,
  ObtengaReporteCrediticioParaDescargar: `${rutaApiInformacionCrediticia}/ObtengaReporteCrediticioParaDescargar?${version}`,
  ObtengaPeriodosArchivosDescargablesPorEntidad: `${rutaApiInformacionCrediticia}/ObtengaPeriodosArchivosDescargablesPorEntidad?${version}`,
  ObtengaDetalleArchivoDescargable: `${rutaApiInformacionCrediticia}/ObtengaDetalleArchivoDescargable?${version}`,
  ObtengaArchivoDescargable: `${rutaApiInformacionCrediticia}/ObtengaArchivoDescargable?${version}`,
  ObtengaFormatoArchivoComportamientoDePago: `${rutaApiInformacionCrediticia}/ObtengaFormatoArchivoComportamientoDePago?${version}`,
};

//API Seguridad
const rutaApiSeguridad = `${dominio}/Seguridad`;
export const apiSeguridad = {
  obtengaUsuarioDelSistema: `${rutaApiSeguridad}/ObtengaUsuarioDelSistema?${version}`,
};

//API Autorizaciones
const rutaApiAutorizaciones = `${dominio}/Autorizacion`;
export const apiAutorizacion = {
  ConsultarAutorizaciones: `${rutaApiAutorizaciones}/ConsultarAutorizaciones?${version}`,
  ObtengaDetalleAutorizacion: `${rutaApiAutorizaciones}/ObtengaDetalleAutorizacion?${version}`,
  ObtengaDocumentoAutorizacion: `${rutaApiAutorizaciones}/ObtengaDocumentoAutorizacion?${version}`,
  ConsultarRevocaciones: `${rutaApiAutorizaciones}/ConsultarRevocaciones?${version}`,
  ObtengaDetalleRevocacion: `${rutaApiAutorizaciones}/ObtengaDetalleRevocacion?${version}`,
  ObtengaUsuariosTramiteAutorizaciones: `${rutaApiAutorizaciones}/ObtengaUsuariosTramiteAutorizaciones?${version}`,
  ObtengaUsuariosTramiteRevocaciones: `${rutaApiAutorizaciones}/ObtengaUsuariosTramiteRevocaciones?${version}`,
  ObtengaDocumentoRevocatoria: `${rutaApiAutorizaciones}/ObtengaDocumentoRevocatoria?${version}`,
  ConsultarPersonaParaAutorizacion: `${rutaApiAutorizaciones}/ConsultarPersonaParaAutorizacion?${version}`,
  IncluirAutorizacion: `${rutaApiAutorizaciones}/IncluirAutorizacion?${version}`,
  ObtengaListaTiposDocumento: `${rutaApiAutorizaciones}/ObtengaListaTiposDocumento?${version}`,
  ObtengaFormularios: `${rutaApiAutorizaciones}/ObtengaFormularios?${version}`,
  ElimineAutorizacion: `${rutaApiAutorizaciones}/ElimineAutorizacion?${version}`,
  RevoqueAutorizacion: `${rutaApiAutorizaciones}/RevoqueAutorizacion?${version}`,
  ConsultarAutorizacionesEliminadas: `${rutaApiAutorizaciones}/ConsultarAutorizacionesEliminadas?${version}`,
  ObtengaUsuariosRolEliminarAutorizaciones: `${rutaApiAutorizaciones}/ObtengaUsuariosRolEliminarAutorizaciones?${version}`,
};

//API Cambios CIC
const rutaCambiosCic = `${dominio}/CambiosCic`;
export const apiCambiosCic = {
  obtengaDatosArchivosPermitidos: `${rutaCambiosCic}/ObtengaDatosArchivosPermitidos?${version}`,
  obtengaOperacionesCambioDeudor: `${rutaCambiosCic}/ObtengaOperacionesCambioDeudor?${version}`,
  obtengaOperacionesCuotasAtrasadas: `${rutaCambiosCic}/ObtengaOperacionesCuotasAtrasadas?${version}`,
  obtengaOperacionesCuentasPorCobrar: `${rutaCambiosCic}/ObtengaOperacionesCuentasPorCobrar?${version}`,
  obtengaOperacionesModificarMotivoLiquidacion: `${rutaCambiosCic}/ObtengaOperacionesModificarMotivoLiquidacion?${version}`,
  obtengaOperacionesIncluirMotivoLiquidacion: `${rutaCambiosCic}/ObtengaOperacionesIncluirMotivoLiquidacion?${version}`,
  obtengaOperacionesCambioCodeudor: `${rutaCambiosCic}/ObtengaOperacionesCambioCodeudor?${version}`,
  obtengaDetalleSolicitudCambio: `${rutaCambiosCic}/ObtengaDetalleSolicitudCambio?${version}`,
  ObtengaOperacionesAEliminar: `${rutaCambiosCic}/ObtengaOperacionesAEliminar?${version}`,
  registrarSolicitudCambioDeudor: `${rutaCambiosCic}/RegistrarSolicitudCambioDeudor?${version}`,
  registrarSolicitudCambioCuotasAtrasadas: `${rutaCambiosCic}/RegistrarSolicitudCuotasAtrasadas?${version}`,
  registrarSolicitudModificacionMotivoLiquidacion: `${rutaCambiosCic}/RegistrarSolicitudModificacionMotivoLiquidacion?${version}`,
  ObtengaListadoSolicitudesCambioCic: `${rutaCambiosCic}/ObtengaListadoSolicitudesCambioCic?${version}`,
  registrarSolicitudIncluirMotivoLiquidacion: `${rutaCambiosCic}/RegistrarSolicitudIncluirMotivoLiquidacion?${version}`,
  registrarSolicitudCambioCodeudor: `${rutaCambiosCic}/RegistrarSolicitudCambioCodeudor?${version}`,
  obtengaArchivoSolicitudCambioCic: `${rutaCambiosCic}/ObtengaArchivoSolicitudCambioCic?${version}`,
  registrarSolicitudCuentasPorCobrar: `${rutaCambiosCic}/RegistrarSolicitudCuentasPorCobrar?${version}`,
  obtengaEstadosSolicitudCambio: `${rutaCambiosCic}/ObtengaEstadosSolicitudCambio?${version}`,
  RechazarSolicitud: `${rutaCambiosCic}/RechazarSolicitud?${version}`,
  ElimineSolicitud: `${rutaCambiosCic}/ElimineSolicitud?${version}`,
  aprobarSolicitud: `${rutaCambiosCic}/ApruebeSolicitud?${version}`,
  registrarSolicitudEliminarOperacion: `${rutaCambiosCic}/RegistrarSolicitudEliminarOperacion?${version}`,
};
